__turbopack_context__.v({
  "className": "inter_ef46b630-module__wxxagW__className",
  "variable": "inter_ef46b630-module__wxxagW__variable",
});
